import { UserServiceClient } from 'fitbeat.api-clients';
import React, { useEffect } from 'react';
import { translate } from 'react-i18next';
import { Platform, ScrollView, StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import { getApiConfig } from '../../config';
import { ProfileHeartRateSetup } from '../../HomeWorkouts/components';
import { StartHeartRateTestScan, UpdateHeartRateMonitorsFn } from '../../HomeWorkouts/heartRateActions';
import { GoogleAnalytics } from '../../services/google-analytics';
import Theme from '../../theme';
import { UserDataConsumer } from '../../utils';
import { AuthTokenBuilder } from '../../utils/authTokenBuilder';
import { loadInitialStateForDashboard, trackingTileSelected } from './../actions';
import TrackingWorkoutTile from './tracking-workout-tile';

const WorkoutPerformanceScreen = ({
    t,
    navigation,
    user: {
        userProfile,
        userProfileService,
        workoutSessionService,
    },
    trackingTileSelected,
    isLoadingWorkout,
    workoutLoadError,
    workoutStats,
    statistics,
    workoutDateRange,
    loadInitialStateForDashboard,
    weeklyWorkoutProgress,
}) => {

    useEffect(() => {
        const onFocusListener = navigation.addListener('didFocus', navigationDidFocus);
        return () => {
            onFocusListener.remove();
        };
    });

    useEffect(() => {
        loadInitialStateForDashboard();
    }, []);

    const isWeb = Platform.OS === 'web';
    const navigationDidFocus = () => loadInitialStateForDashboard();

    return (
        <View style={styles.container}>
            <View style={styles.paddedContainer}>
                <>
                    <ScrollView>
                        <TrackingWorkoutTile
                            trackingTileSelected={trackingTileSelected}
                            workoutSessionService={workoutSessionService}
                            isLoading={isLoadingWorkout}
                            loadingError={workoutLoadError}
                            workoutStats={workoutStats}
                            navigation={navigation}
                            totals={statistics ? statistics.totals : 0}
                            workoutStatsDateRange={workoutDateRange}
                            userProfile={userProfile}
                            weeklyWorkoutProgress={weeklyWorkoutProgress}/>
                    </ScrollView>
                    {Platform.OS !== 'web' &&
                        <ProfileHeartRateSetup
                            userProfile={userProfile}
                            heartRateScanAction={StartHeartRateTestScan}
                            userUpdateFunc={userProfileService.updateUserProfileAsync}
                            updateUserHeartRateMonitors={userProfileService.updateUserHeartRateMonitors}
                        />
                    }
                </>
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        backgroundColor: Theme.GREY_LIGHT,
        height: '100%',
    },
    paddedContainer: {
        zIndex: 1000,
        flex: 1,
    },
});

const mapStateToProps = (state: any) => {
    const { isLoadingWorkout, workoutLoadError } = state.tracking.view;
    const { workoutDateRange } = state.tracking.view.dashboard;
    const { stats, workoutStats } = state.tracking.data.dashboard;
    const { weeklyWorkoutProgress } = state.tracking.data;
    return {
        isLoadingWorkout,
        workoutLoadError,
        workoutStats,
        statistics: stats,
        workoutDateRange,
        weeklyWorkoutProgress,
    };
};

const mapDispatchToProps = (dispatch: any, ownProps: any) => {
    return {
        loadInitialStateForDashboard: () => dispatch(loadInitialStateForDashboard(ownProps.user.userServiceClient, new Date())),
        trackingTileSelected: (tileName) => dispatch(trackingTileSelected(tileName)),
    };
};

export const TrackingWorkoutPerformanceScreen = UserDataConsumer(connect(mapStateToProps, mapDispatchToProps)
    (translate(['stats', 'tracking'], { wait: true })(WorkoutPerformanceScreen)));
